import { get } from 'lodash';

import {
    redirectToLogout,
} from '../actions/ui-state-action-creators';

const unauthorizedMiddleware = store => next => action => {
    const alreadyAuthenticating = ['/', '/login', '/verify'].includes( window.location.pathname );
    const is401 = get( action, 'error.status', false ) === 401 || get( action, 'error.response.status', false ) === 401;
    if(  is401 && !alreadyAuthenticating  ){
        store.dispatch( redirectToLogout() );
    }
    else{
        return next( action );
    }
};

export default unauthorizedMiddleware;
